import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export class NumberOptionsVM extends CommonOptionVM {
  required?: boolean
  secure?: boolean
  require_media?: boolean
  require_note?: boolean
  read_only?: boolean
  decimal?: number
  min?: number
  max?: number
  default_value?: number | null
  grouping_separator?: boolean
  unit_type?: string
  units?: string[] | null
  simple_rule?: SimpleRuleItem[];
  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<NumberOptionsVM> = {}) {
    super(data)
    this.decimal = data?.decimal ?? undefined
    this.min = data?.min ?? undefined
    this.max = data?.max ?? undefined
    this.default_value = data?.default_value || undefined
    this.grouping_separator = data?.grouping_separator ?? undefined
    this.unit_type = data?.unit_type ?? undefined
    this.units = data.units ?? undefined
    this.required = data?.required ?? undefined
    this.secure = data?.secure ?? undefined
    this.require_media = data?.require_media ?? undefined
    this.require_note = data?.require_note ?? undefined
    this.read_only = data?.read_only ?? undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    // Check if default value is required when hidden or readonly is enabled
    if ((this.secure || this.read_only) && (this.default_value === undefined || this.default_value === null)) {
      errors.push({ key: 'default_value', error_message: 'Default value is required when secure or read-only is enabled' })
    }

    // Check if default value is within min/max range
    if (this.default_value !== undefined && this.default_value !== null) {
      if (this.min !== undefined && this.default_value < this.min) {
        errors.push({ key: 'default_value', error_message: 'Default value must be greater than or equal to minimum value' })
      }
      if (this.max !== undefined && this.default_value > this.max) {
        errors.push({ key: 'default_value', error_message: 'Default value must be less than or equal to maximum value' })
      }

      // Check decimal places
      if (this.decimal !== undefined && this.decimal !== null) {
        const decimalPlaces = (this.default_value.toString().split('.')[1] || '').length
        if (decimalPlaces > this.decimal) {
          errors.push({ key: 'default_value', error_message: `Default value cannot have more than ${this.decimal} decimal places` })
        }
      }
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default NumberOptionsVM